"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class JournalCache {
    constructor(cache) {
        this.cache = cache;
        this.getLifeJournalEntry = async (customerId, date, getRequest) => {
            return this.cache.get(`JOURNAL.LIFE.${date}.${customerId}`, getRequest);
        };
        this.getMindJournalEntry = async (customerId, date, getRequest) => {
            return this.cache.get(`JOURNAL.MIND.${date}.${customerId}`, getRequest);
        };
    }
}
exports.default = JournalCache;
//# sourceMappingURL=JournalCache.js.map